import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';

import * as yup from 'yup';

/** Passage task update API request body - DTO signature */
export interface PassageTaskFormInterface {
  /** Client this task belongs to */
  client: ClientFindInterface;
  /** Passage date */
  date: Date;
  /** Guest's full name */
  name: string;
  /** External user who created this passage task */
  externalUser?: ExternalUserFindInterface;
  /** User who created this passage task */
  createdBy?: UserFindInterface;
}

/** Passage task update API request body - DTO schema */
export const PassageTaskFormDto = SerdeDtoClass.create<PassageTaskFormInterface>(PacsDtoKeysEnum.PASSAGE_TASK_FORM_DTO, {
  client: {
    sortable: true,
    label: 'Клиент',
    serializer: entityLikeSchema,
  },
  name: {
    sortable: true,
    label: 'ФИО гостя',
    serializer: nonEmptyStringSchema,
  },
  date: {
    sortable: true,
    label: 'Дата прихода',
    serializer: yup.date(),
  },
  externalUser: {
    optional: true,
    sortable: true,
    label: 'Внешний пользователь',
    serializer: entityLikeSchema,
  },
  createdBy: {
    optional: true,
    sortable: true,
    label: 'Пользователь',
    serializer: entityLikeSchema,
  },
});
